<template>
  <div>
    <div class="card card-inverse card-success text-xs-center" v-if="billingLevel === 0">
      <div class="card-block">
        <blockquote class="card-blockquote">
          Facturation du client à jour.
        </blockquote>
      </div>
    </div>
    <div class="card card-inverse card-warning text-xs-center" v-if="billingLevel === 1">
      <div class="card-block">
        <blockquote class="card-blockquote">
          Facturation du client en retard.
        </blockquote>
      </div>
    </div>
    <div class="card card-inverse card-danger text-xs-center" v-if="billingLevel === 2">
      <div class="card-block">
        <blockquote class="card-blockquote">
          Facturation du client en recouvrement.
        </blockquote>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'customer-billing-summary-widget',
    props: ['customer'],
    computed: {
      billingLevel () {
        if (this.customer.meta.document_flag_litigation_invoice_count > 0) {
          return 2
        } else if (this.customer.meta.document_flag_overdue_invoice_count > 0) {
          return 1
        } else {
          return 0
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CustomerBillingSummaryWidget.vue?09969218